// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cd-2";
export var aiChatCartContainerExit = "_cd-4";
export var aiChatContainerLarge = "_cd-0";
export var aiChatContainerSmall = "_cd-1";
export var aiChatIcon = "_cd-6";
export var slideInFromRight = "_cd-3";
export var slideOutToRight = "_cd-5";